import { lazy, Suspense } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import * as TYPE from "./lib/contrant";
import LuckyUser from "./pages/LuckyMoney/LuckyUser";
import ListBuyUSDT from "./pages/Transaction/ListBuyUSDT";
import ListBuyXAU from "./pages/Transaction/ListBuyXAU";
import ListSwapTON from "./pages/Transaction/ListSwapTON";
import ListSellXAU from "./pages/Transaction/ListSellXAU";
import ListDepositUSDT from "./pages/Transaction/ListDepositUSDT";
import ListSellUSDT from "./pages/Transaction/ListSellUSDT";
import ListAuthor from "./pages/Post/ListAuthor";
import ListExpert from "./pages/Post/ListExpert";
import ListCategorySEO from "./pages/Post/ListCategorySEO";
import CreateUpdateCategorySEO from "./pages/Post/CreateUpdateCategorySEO";

const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

const Dashboard = lazy(() => import("./pages/Dashboard"));

const ListUserAdmin = lazy(() => import("./pages/Admin/ListUserAdmin"));
const SettingMenu = lazy(() => import("./pages/Admin/SettingMenu"));

const ListRole = lazy(() => import("./pages/Role/ListRole"));

const ListGroupPermission = lazy(() =>
  import("./pages/GroupPermission/ListGroupPermission")
);
const Statistical = lazy(() => import("./pages/Admin/Statistical"));

const GoldPriceGroup = lazy(() => import("./pages/GoldPrice/GoldPriceGroup"));
const GoldPriceOfficial = lazy(() =>
  import("./pages/GoldPrice/GoldPriceOfficial")
);

const GoldPriceReference = lazy(() =>
  import("./pages/GoldPrice/GoldPriceReference")
);

const GoldPriceHana = lazy(() => import("./pages/GoldPrice/GoldPriceHana"));
const ManageRateReference = lazy(() =>
  import("./pages/GoldPrice/ManageRateReference")
);
const ManageRateOfficial = lazy(() =>
  import("./pages/GoldPrice/ManageRateOfficial")
);

const ListPermission = lazy(() => import("./pages/Permission/ListPermission"));
const ListRefferal = lazy(() => import("./pages/User/ListRefferal"));
const ListMilestoneRefferal = lazy(() =>
  import("./pages/User/ListMilestoneRefferal")
);
const ListBusinessVoucher = lazy(() =>
  import("./pages/Voucher/BusinessVoucher")
);
const ListEvoucherConfig = lazy(() => import("./pages/Voucher/EvoucherConfig"));
const ListBusinessVoucherSub = lazy(() =>
  import("./pages/Voucher/BusinessVoucherSub")
);
const ListCashBack = lazy(() => import("./pages/User/ListCashback"));
const ListMilestone = lazy(() => import("./pages/User/ListMilestone"));
const DetailReferral = lazy(() => import("./pages/User/DetailReferral"));
const ListStakingDaily = lazy(() =>
  import("./pages/Transaction/ListStakingDaily")
);
const DetailInvest = lazy(() => import("./pages/Invest/DetailInvest"));
const DetailMileStoneReferral = lazy(() =>
  import("./pages/User/DetailMilestoneReferral")
);
const ListUser = lazy(() => import("./pages/User/ListUser"));
const ListInvest = lazy(() => import("./pages/Invest/ListInvest"));
const ListUserMoney = lazy(() => import("./pages/User/ListUserMoney"));
const ListUserAssets = lazy(() => import("./pages/User/ListUserAssets"));
const ListUserCoinLock = lazy(() => import("./pages/User/ListUserCoinLock"));

const ListUserMaster = lazy(() => import("./pages/Master/ListUserMaster"));

const MasterHistory = lazy(() => import("./pages/Master/History"));

const UserProfile = lazy(() => import("./pages/User/UserProfile"));

const ChangePassword = lazy(() => import("./pages/User/ChangePassword"));

const AdminProfile = lazy(() => import("./pages/User/AdminProfile"));

const ListKYC = lazy(() => import("./pages/KYC/index"));
const ListLockWithdraw = lazy(() => import("./pages/LockWithdrawUser/index"));

const UserKYCDetail = lazy(() => import("./pages/KYC/UserKYC"));
const TopRunner = lazy(() => import("./pages/User/TopRunner"));
const Event = lazy(() => import("./pages/User/Event"));

const UpdateProduct = lazy(() =>
  import("./pages/Product/CreateOrUpdateProduct")
);

const UpdateProductCategory = lazy(() =>
  import("./pages/Product/CreateOrUpdateProductCategory")
);

const ListProductCategory = lazy(() => import("./pages/Product/ListCategory"));
const HistoryChangeCoinList = lazy(() =>
  import("./pages/Master/ListChangeCoin")
);
const ListProduct = lazy(() => import("./pages/Product/ListProduct"));
const ListTagProduct = lazy(() => import("./pages/Product/ListTagProduct"));
const UploadProducts = lazy(() => import("./pages/Product/UploadProducts"));

const ListSpecifications = lazy(() =>
  import("./pages/Product/ListSpecifications")
);
const DetailPost = lazy(() => import("./pages/Post/DetailPost"));
const CreateUpdateExpert = lazy(() => import("./pages/Post/CreateUpdateExpert"));
const CreateUpdateCategory = lazy(() => import("./pages/Post/CreateUpdateCategory"));
const ListPost = lazy(() => import("./pages/Post/ListPost"));
const ListPostAgency = lazy(() => import("./pages/Post/ListPostAgency"));
// const ListPostAgency = lazy(() =>
//     import("./pages/Post/ListAgencyPost")
// );
const ListTag = lazy(() => import("./pages/Post/ListTag"));
const ListPnl = lazy(() => import("./pages/User/ListPnl"));
const ListPostCategory = lazy(() => import("./pages/Post/ListCategory"));

const ListGoldPrice = lazy(() => import("./pages/GoldPrice/ListGoldPrice"));

const ListGold = lazy(() => import("./pages/GoldPrice/ListGold"));

const ListMerchant = lazy(() => import("./pages/Merchant/ListMerchant"));

const MerchantDetail = lazy(() => import("./pages/Merchant/MerchantDetail"));

const ListShop = lazy(() => import("./pages/Shop/ListShop"));

const HistoryGoldPrice = lazy(() =>
  import("./pages/GoldPrice/HistoryGoldPrice")
);

const ListTranferGold = lazy(() =>
  import("./pages/Transaction/ListTranferGold")
);
const ListCommissionsAgents = lazy(() =>
  import("./pages/Transaction/ListCommissionsAgents")
);

const ListMoneyTransaction = lazy(() =>
  import("./pages/Transaction/ListMoneyTransaction")
);
const ListWithdrawMoney = lazy(() =>
  import("./pages/Transaction/ListWithdrawMoney")
);
const ListWithdrawUSDT = lazy(() =>
  import("./pages/Transaction/ListWithdrawUSDT")
);
const ListRequestClaim = lazy(() =>
  import("./pages/Transaction/ListRequestClaim")
);
const ListProductProperty = lazy(() => import("./pages/Product/ListProperty"));
const PropertyDetail = lazy(() => import("./pages/Product/PropertyDetail"));
const ListRequestUpgradeUser = lazy(() =>
  import("./pages/User/ListUserUpgrade")
);
const ListSuccessUpgrade = lazy(() =>
  import("./pages/User/ListSuccessUpgrade")
);
const ListOrder = lazy(() => import("./pages/Order/OrderList"));
const ListConfig = lazy(() => import("./pages/Admin/ListConfig"));
const GoldConfigClone = lazy(() => import("./pages/Admin/ConfigPrice/ConfigArbitrageGoldClone"));
const HNGConfigClone = lazy(() => import("./pages/Admin/ConfigPrice/ConfigArbitrageHNGClone"));
const ListMarketingConfig = lazy(() =>
  import("./pages/CampaignSetting/ListCampaign")
);

const VoiceBot = lazy(() => import("./pages/VoiceBot/VoiceBot"));
const ListVoucher = lazy(() => import("./pages/Order/ListVoucher"));
const ListUserVoucher = lazy(() => import("./pages/Order/ListUserVoucher"));
const ListTransactionGold = lazy(() =>
  import("./pages/Transaction/ListTransactionGold")
);
const ListSellGold = lazy(() => import("./pages/Transaction/ListSellGold"));
const ListSwapHNG = lazy(() => import("./pages/Transaction/ListSwapHNG"));
const ListSwapBuyHNG = lazy(() => import("./pages/Transaction/ListSwapBuyHNG"));
const ListBuyGold = lazy(() => import("./pages/Transaction/ListBuyGold"));

const DetailTransactionGold = lazy(() =>
  import("./pages/Transaction/DetailTransactionGold")
);
const ListBank = lazy(() => import("./pages/Transaction/ListBank"));
const ListPartner = lazy(() => import("./pages/Partner/PartnerList"));
const ListBankConfig = lazy(() => import("./pages/Transaction/ListBankConfig"));

const ListAgency = lazy(() => import("./pages/Agency/ListAgency"));
const ListRevenueAgency = lazy(() =>
  import("./pages/Agency/ListRevenueAgency")
);
const ListConfigAgency = lazy(() => import("./pages/Agency/ListConfigAgency"));
const ListRequestAgency = lazy(() =>
  import("./pages/Agency/ListRequestAgency")
);
const ListRequestAgencyLevelOne = lazy(() =>
  import("./pages/Agency/ListRequestAgencyLevelOne")
);
const ListRequestPartners = lazy(() =>
  import("./pages/Agency/ListRequestPartners")
);
const HistoryRoot = lazy(() => import("./pages/Dashboard/HistoryRoot"));

const ScreenBanner = lazy(() =>
  import("./pages/ScreenBanner/ListScreenBanner")
);
const BannerHomepage = lazy(() =>
  import("./pages/BannerHomepage/ListBannerHomepage")
);

const ListPopup = lazy(() => import("./pages/Popup/ListPopup"));
const ListSettingShowPopup = lazy(() =>
  import("./pages/Popup/ListSettingShowPopup")
);

const ListPageSetting = lazy(() => import("./pages/PageSetting/List"));
const DetailPageSetting = lazy(() => import("./pages/PageSetting/Detail"));
const HomePage = lazy(() => import("./pages/PageSetting/Home"));
const Collaborator = lazy(() => import("./pages/PageSetting/Collaborator"));
const FranchisePartners = lazy(() =>
  import("./pages/PageSetting/FranchisePartners")
);
const Phoenix = lazy(() => import("./pages/PageSetting/Phoenix"));

const Accumulation = lazy(() => import("./pages/Accumulation/index"));

const ConfigNotify = lazy(() => import("./pages/Notify/ConfigNotify"));
const ConfigNotifyHNG = lazy(() => import("./pages/Notify/ConfigNotifyHNG"));

const SendNotify = lazy(() => import("./pages/Notify/SendNotify"));

const SendNotifyOnesignal = lazy(() => import("./pages/Notify/SendOnesignal"));

const HistoryNotifyOnesignal = lazy(() =>
  import("./pages/Notify/HistoryNotify")
);

const ListUserAccumulation = lazy(() =>
  import("./pages/Accumulation/ListUserAccumulation")
);

const Loan = lazy(() => import("./pages/Loan/index"));
const MoneyManager = lazy(() => import("./pages/Dashboard/MoneyManager"));
const ListImageProduct = lazy(() =>
  import("./pages/ImageProduct/ListImageProduct")
);

const LoanUserCredit = lazy(() => import("./pages/Loan/ListUserCredit"));
const LoanUserCreditHistory = lazy(() => import("./pages/Loan/History"));

const SendGoldListUser = lazy(() =>
  import("./pages/Transaction/SendGoldToListUser")
);
const ListNFC = lazy(() => import("./pages/NFC/ListNFC"));
const ListNFCReport = lazy(() => import("./pages/NFC/ListNFCReport"));
const AgencyBonus = lazy(() => import("./pages/Setting/AgencyBonus"));
const CreateCommission = lazy(() =>
  import("./pages/CommissionCMS/CreateCommission")
);
const ListCommissionCMS = lazy(() =>
  import("./pages/CommissionCMS/ListCommissionCMS")
);
const VerifyTransaction = lazy(() =>
  import("./pages/VerifyTransaction/VerifyTransaction")
);

const ListVideo = lazy(() => import("./pages/VideoPost/ListVideo"));
const ListVideoHomepage = lazy(() =>
  import("./pages/VideoHomepage/ListVideoHomepage")
);

const ListUserBank = lazy(() => import("./pages/User/ListUserBank"));

const ListRequestMerchantHNG = lazy(() =>
  import("./pages/MerchantHNG/ListRequestMerchantHNG")
);

const LuckyMoney = lazy(() => import("./pages/LuckyMoney/LuckyMoney"));
const LuckyHistory = lazy(() => import("./pages/LuckyMoney/LuckyHistory"));
const ConfigureProgram = lazy(() =>
  import("./pages/LuckyMoney/ConfigureProgram")
)
;const ListMerchantHNG = lazy(() => import('./pages/MerchantHNG/ListMerchantHNG'))
const ListUserMerchantHNG = lazy(() => import('./pages/MerchantHNG/ListUserMerchantHNG'))

const ConfigMerchantHNG = lazy(() => import('./pages/MerchantHNG/ConfigMerchantHNG'))


// Priority
const PriorityConfig = lazy(() => import("./pages/Priority/PriorityConfig"));
const PriorityBenefitConfig = lazy(() => import("./pages/Priority/PriorityBenefitConfig"));
const PriorityUpgradeRequest = lazy(() => import("./pages/Priority/PriorityUpgradeRequest"));
const PriorityUser = lazy(() => import("./pages/Priority/PriorityUser"));
const PriorityUserDetail = lazy(() => import("./pages/Priority/PriorityUserDetail"));
// End Priority

export default function BasePage() {
  const { listUserLoginPermission } = useSelector(
    (state) => ({
      listUserLoginPermission: state.authReducer.listUserLoginPermission,
    }),
    shallowEqual
  );

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        {/* Trang chủ */}
        <ContentRoute path="/dashboard" component={Dashboard} exact />
        <ContentRoute path="/money-manage" component={MoneyManager} exact />
        {/* end */}
        <Route path="/user-profile" component={UserProfilepage} exact />
        <Route path="/root-account" component={HistoryRoot} exact />
        {/* Quản trị hệ thống */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_VAI_TRO) && (
          <Route path="/admin/role" component={ListRole} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_QUYEN) && (
          <Route path="/admin/permission" component={ListPermission} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NHOM_QUYEN) && (
          <Route
            path="/admin/group-permission"
            component={ListGroupPermission}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_VAI_TRO) && (
          <Route path="/admin/settingMenu" component={SettingMenu} exact />
        )}
        {/*{listUserLoginPermission.includes(TYPE.QUAN_LY_NHOM_QUYEN) && */}
        {["user", "commission", "purchase", "dau", "assets"].map((sPath) => (
          <Route path={`/statistical/${sPath}`} component={Statistical} />
        ))}
        {/*}*/}
        <Route path={`/gold_price/group`} component={GoldPriceGroup} />
        <Route path={`/gold_price/official`} component={GoldPriceOfficial} />
        <Route path={`/gold_price/reference`} component={GoldPriceReference} />
        <Route path={`/gold_price/hana`} component={GoldPriceHana} />
        <Route path={`/rate_mana/reference`} component={ManageRateReference} />
        <Route path={`/rate_mana/official`} component={ManageRateOfficial} />

        {/* end */}
        {/* Quản lý master */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_DS_MASTER) && (
          <Route path="/system-account" component={ListUserMaster} exact />
        )}
        <Route
          path="/master/history/:typeMaster"
          component={MasterHistory}
          exact
        />
        {/* quản lý cho vay tiền  */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_CHO_VAY) && (
          <Route path="/loan/list" component={Loan} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_CHO_VAY) && (
          <Route path="/loan/user_list" component={LoanUserCredit} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_CHO_VAY) && (
          <Route
            path="/loan/user_history_pay"
            component={LoanUserCreditHistory}
            exact
          />
        )}
        {/* Quản lý người dùng */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_ADMIN) && (
          <Route path="/admin/list-user" component={ListUserAdmin} exact />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.QUAN_TRI_NGUOI_DUNG)) && (
          <Route path="/user/list-user" component={ListUser} exact />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.QUAN_TRI_NGUOI_DUNG)) && (
          <Route path="/user/top-runner" component={TopRunner} exact />
        )}
          {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.QUAN_TRI_NGUOI_DUNG)) && (
          <Route path="/event" component={Event} exact />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_NGUOI_DUNG)) && (
          <Route path="/user/profile/:id" component={UserProfile} exact />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.DANH_SACH_YEU_CAU_KYC)) && (
          <Route path="/user/list-kyc" component={ListKYC} exact />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.DANH_SACH_YEU_CAU_KYC)) && (
          <Route path="/user/kyc/:id" component={UserKYCDetail} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) && (
          <Route
            path="/user/list-lock-withdraw"
            component={ListLockWithdraw}
            exact
          />
        )}
        {/* end */}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) ||
          listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_DAI_SU)) && (
          <Route path="/agency/list" component={ListAgency} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) && (
          <Route
            path="/agency/list-revenue"
            component={ListRevenueAgency}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) && (
          <Route
            path="/agency/request/list"
            component={ListRequestAgency}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) && (
          <Route
            path="/agency/request/level/listLevelOne"
            component={ListRequestAgencyLevelOne}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) && (
          <Route
            path="/agency/partners/list"
            component={ListRequestPartners}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) && (
          <Route
            path="/agency/config_list"
            component={ListConfigAgency}
            exact
          />
        )}
        {/* Quản lý đại lý */}
        {/* end */}
        {/* Quản lý admin */}
        <Route path="/admin/change-password" component={ChangePassword} exact />
        <Route path="/admin/profile" component={AdminProfile} exact />
        {/* end */}
        {/* Quản lý gói đầu tư */}
        <Route path="/accumulation/list" component={Accumulation} exact />
        <Route
          path="/accumulation/list-accumulation/:id"
          component={ListUserAccumulation}
          exact
        />
        {/* End */}
        {/* Quản lý sản phẩm */}
        <Route path="/product/update/:id" component={UpdateProduct} exact />
        <Route path="/product/create" component={UpdateProduct} exact />
        <Route
          path="/product/category/list"
          component={ListProductCategory}
          exact
        />
        <Route path="/product/list" component={ListProduct} exact />
        <Route
          path="/product/specifications/list"
          component={ListSpecifications}
          exact
        />
        <Route
          path="/product/category/update"
          component={UpdateProductCategory}
          exact
        />
        <Route
          path="/product/property/list"
          component={ListProductProperty}
          exact
        />
         <Route
          path="/product/detail/:id"
          component={PropertyDetail}
          exact
        />
        {/* QUẢN LÝ PRIORITY */}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_PRIORITY) && (
          <Route path="/priority/config" component={PriorityConfig} exact />
        ))}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_PRIORITY) && (
          <Route path="/priority/benefit/config" component={PriorityBenefitConfig} exact />
        ))}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_PRIORITY) && (
          <Route path="/priority/upgrade/list" component={PriorityUpgradeRequest} exact />
        ))}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_PRIORITY) && (
          <Route path="/priority/user/list" component={PriorityUser} exact />
        ))}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_PRIORITY) && (
          <Route path="/priority/user/detail/:id" component={PriorityUserDetail} exact />
        ))}
        {/* END PRIORITY */}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_DON_HANG) ||
          listUserLoginPermission.includes(TYPE.DANH_SACH_DON_HANG)) && (
          <Route path="/order/list" component={ListOrder} />
        )}
        <Route path="/system-config/general" component={ListConfig} />
        <Route path="/system-config/gold" component={GoldConfigClone} />
        <Route path="/system-config/hng" component={HNGConfigClone} />
        <Route path="/campaign-config" component={ListMarketingConfig} />
        <Route path="/voice-bot" component={VoiceBot} />
        <Route path="/lucky-management/list-config" component={LuckyMoney} />
        <Route path="/lucky-management/list-receiver" component={LuckyUser} />
        <Route
          path="/lucky-management/history/:configureProgramId"
          component={LuckyHistory}
        />
        <Route
          path="/lucky-management/configure-program"
          component={ConfigureProgram}
        />
        <Route path="/order/voucher" component={ListVoucher} />
        <Route path="/order/user_voucher" component={ListUserVoucher} />
        <Route path="/product/list/tag" component={ListTagProduct} exact />
        <Route path="/product/upload" component={UploadProducts} exact />
        <Route path="/nfc/list" component={ListNFC} exact />
        <Route path="/nfc/list-report" component={ListNFCReport} exact />
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_DAU_TU) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_CUNG_HOP_TAC)) && (
          <Route
            path="/accumulation/invest/list"
            component={ListInvest}
            exact
          />
        )}
        <Route
          path="/accumulation/invest/detail/:id"
          component={DetailInvest}
          exact
        />
        {/* end */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) && (
          <Route path="/page_setting/list" component={ListPageSetting} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) && (
          <Route path="/page_setting/home" component={HomePage} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) && (
          <Route
            path="/page_setting/franchise-partners"
            component={FranchisePartners}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) && (
          <Route
            path="/page_setting/collaborator"
            component={Collaborator}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) && (
          <Route path="/page_setting/phoenix" component={Phoenix} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) && (
          <Route path="/page_setting/:id" component={DetailPageSetting} exact />
        )}
        {/* Quản lý nội dung */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/content/list" component={ListPost} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/content/post/:id" component={DetailPost} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/expert/:id" component={CreateUpdateExpert} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/content/edit/category/:id" component={CreateUpdateCategory} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/content/tag/list" component={ListTag} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route
            path="/content/category/list"
            component={ListPostCategory}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/video_post/list" component={ListVideo} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/author" component={ListAuthor} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/expert" component={ListExpert} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/category-seo" component={ListCategorySEO} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/category-seo/:id" component={CreateUpdateCategorySEO} exact />
        )}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && ( */}
        <Route
          path="/video_post/video-homepage"
          component={ListVideoHomepage}
          exact
        />
        {/* )} */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <Route path="/post_agency/list" component={ListPostAgency} exact />
        )}
        {/* end */}
        {/* Quản lý giá vàng */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG) && (
          <Route
            path="/gold/gold-price/list/:id"
            component={HistoryGoldPrice}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG) && (
          <Route path="/gold/gold-price/list" component={ListGoldPrice} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG) && (
          <Route path="/gold/list" component={ListGold} exact />
        )}
        {/* end */}
        {/* Quản lý chi nhánh */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_CHI_NHANH) && (
          <Route path="/shop/list" component={ListShop} exact />
        )}
        {/* end */}
        {/* Quản lý giao dịch */}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.XEM_NAP_TIEN)) && (
          <Route
            path="/transaction/money/list"
            component={ListMoneyTransaction}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.XEM_MUA_VANG)) && (
          <Route
            path="/transaction/buy-gold/list"
            component={ListBuyGold}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_HNG)) && (
          <Route
            path="/transaction/list-swap-buy-hng"
            component={ListSwapBuyHNG}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_HNG)) && (
          <Route
            path="/transaction/list-swap-hng"
            component={ListSwapHNG}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_USD)) && (
          <Route
            path="/transaction/list-buy-usdt"
            component={ListBuyUSDT}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_USD)) && (
          <Route
            path="/transaction/list-sell-usdt"
            component={ListSellUSDT}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) && (
          <Route
            path="/transaction/list-buy-xau"
            component={ListBuyXAU}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_BAN_XAU)) && (
          <Route
            path="/transaction/list-sell-xau"
            component={ListSellXAU}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) && (
          <Route
            path="/transaction/list-swap-ton"
            component={ListSwapTON}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/withdraw-money/list"
            component={ListWithdrawMoney}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/deposit-usdt/list"
            component={ListDepositUSDT}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/withdraw-usdt/list"
            component={ListWithdrawUSDT}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/withdraw-prize/list"
            component={ListRequestClaim}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/gold_t/list"
            component={ListTransactionGold}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/gold_t/detal"
            component={DetailTransactionGold}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/sell-gold/list"
            component={ListSellGold}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/gold/tranfer/list"
            component={ListTranferGold}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/staking-daily"
            component={ListStakingDaily}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/commissions_agents"
            component={ListCommissionsAgents}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIEN) && (
          <Route path="/money-management" component={ListUserMoney} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_VANG) && (
          <Route path="/assets-management" component={ListUserAssets} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NGAN_HANG) && (
          <Route path="/bank/list" component={ListBank} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NGAN_HANG) && (
          <Route path="/partner/list" component={ListPartner} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NGAN_HANG) && (
          <Route path="/bank/config" component={ListBankConfig} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIEN_VANG_KHOA) && (
          <Route path="/list-coin-lock" component={ListUserCoinLock} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
          <Route
            path="/transaction/send-gold-list-user"
            component={SendGoldListUser}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_DS_GIAO_DICH) && (
          <Route
            path="/system-change-balance"
            component={HistoryChangeCoinList}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_BANNER) && (
          <Route path="/screen-banner" component={ScreenBanner} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_BANNER) && (
          <Route path="/banner-homepage" component={BannerHomepage} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_POPUP) && (
          <Route path="/popup/list" component={ListPopup} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_POPUP) && (
          <Route
            path="/popup/show-popup"
            component={ListSettingShowPopup}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) && (
          <Route path="/notify/config" component={ConfigNotify} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) && (
          <Route path="/notify/HNG" component={ConfigNotifyHNG} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) && (
          <Route path="/notify/send" component={SendNotify} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) && (
          <Route
            path="/notify/onesignal"
            component={SendNotifyOnesignal}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) && (
          <Route
            path="/notify/onesignal/:id"
            component={SendNotifyOnesignal}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) && (
          <Route
            path="/notify/history"
            component={HistoryNotifyOnesignal}
            exact
          />
        )}
        {listUserLoginPermission.includes(TYPE.THUONG_KYC_DAI_LY) && (
          <Route path="/agency-bonus" component={AgencyBonus} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_MERCHANT) && (
          <Route path="/merchant" component={ListMerchant} exact />
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_MERCHANT) && (
          <Route path="/merchant/:id" component={MerchantDetail} exact />
        )}
        {/* end */}
        <Route
          path="/product/image_product/list"
          component={ListImageProduct}
          exact
        />
        <Route path="/user/list-pnl" component={ListPnl} exact />
        <Route
          path="/user/introductoryLandmark"
          component={ListMilestoneRefferal}
          exact
        />
        <Route
          path="/voucher/business-voucher"
          component={ListBusinessVoucher}
          exact
        />
        <Route
          path="/voucher/evoucher-config"
          component={ListEvoucherConfig}
          exact
        />
        <Route
          path="/voucher/business-voucher/:id"
          component={ListBusinessVoucherSub}
          exact
        />
        <Route path="/user/commission" component={ListCashBack} exact />
        <Route path="/user/milestone" component={ListMilestone} exact />
        <Route
          path="/user/introductoryLandmark/:id"
          component={DetailMileStoneReferral}
          exact
        />
        <Route
          path="/commission_cms/create"
          component={CreateCommission}
          exact
        />
        <Route
          path="/commission_cms/get-list"
          component={ListCommissionCMS}
          exact
        />
        <Route
          path="/upgrade/list-success-upgrade"
          component={ListSuccessUpgrade}
          exact
        />
        <Route
          path="/verify/verify-transaction"
          component={VerifyTransaction}
          exact
        />
        <Route path="/bank/bank-by-user" component={ListUserBank} exact />
        <Route path="/merchant_hng/list" component={ListMerchantHNG} exact />
        <Route path="/merchant_hng/list/:id" component={ListUserMerchantHNG} exact />
        <Route path="/merchant_hng/config" component={ConfigMerchantHNG} exact />
        <Route
          path="/merchant_hng/request"
          component={ListRequestMerchantHNG}
          exact
        />
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(
            TYPE.DANH_SACH_NGUOI_DA_GIOI_THIEU
          )) && (
          <Route path="/user/referral/:id" component={DetailReferral} exact />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(
            TYPE.DANH_SACH_NGUOI_DA_GIOI_THIEU
          )) && <Route path="/user/referral" component={ListRefferal} exact />}
        <Route path="/bank/bank-by-user" component={ListUserBank} exact />
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(
            TYPE.DANH_SACH_YEU_CAU_NANG_CAP
          )) && (
          <Route
            path="/user/list-request-upgrade-user"
            component={ListRequestUpgradeUser}
            exact
          />
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(
            TYPE.DANH_SACH_NGUOI_DA_GIOI_THIEU
          )) && <Route path="/user/referral" component={ListRefferal} exact />}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(
            TYPE.DANH_SACH_NGUOI_DA_GIOI_THIEU
          )) && (
          <Route path="/user/referral/:id" component={DetailReferral} exact />
        )}
        <Redirect from="/login" to="/" />
      </Switch>
    </Suspense>
  );
}
